import {
  areOptionsGrouped,
  FilterSettings,
  FiltersObject,
  OptionGroup,
} from './types';

export const createSettings = <O extends FiltersObject, T>(
  settings: FilterSettings<O, T>
): FilterSettings<O, T> => {
  return settings;
};

export const getFilteredOptions = <T extends string[] | OptionGroup[]>(
  options: T,
  searchValue: string,
  getOptionLabel: (option: string) => string
) => {
  const isOptionIncludedInSearch = (option: string) =>
    getOptionLabel(option).toLowerCase().includes(searchValue.toLowerCase()) ||
    option.toLowerCase().includes(searchValue.toLowerCase());

  if (areOptionsGrouped(options)) {
    return options.flatMap(group => {
      const isWorkspaceValid = group.label
        .toLowerCase()
        .includes(searchValue.toLowerCase());

      if (isWorkspaceValid) return group;

      const filteredQueues = group.options.filter(isOptionIncludedInSearch);

      return filteredQueues.length
        ? {
            ...group,
            options: filteredQueues,
          }
        : [];
    });
  }

  return options.filter(
    option => !searchValue || isOptionIncludedInSearch(option)
  );
};
